import InlineSVG from '../../icons';
import PropTypes from 'prop-types';
import React from 'react';

const SocialLink = ({link}) => {
    const {key, url} = link;
    return (
        <a href={url} className="social-link">
            <InlineSVG
                name="hexButton"
                className="hexButton"
                viewBox="0 0 26.33 30.77"/>
            <span className= {`icon icon-${key}`} />
        </a>
    );
};
SocialLink.propTypes = {
    link: PropTypes.object
}

export default SocialLink;
